import { SNACKBARS_STACK_SUSPEND, SnackbarsStackAction } from './types';

export const suspendSnackbarsStack = (
): SnackbarsStackAction => ({
  type: SNACKBARS_STACK_SUSPEND
});
